var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#374f68;}.cls-2{fill:#425b72;}.cls-3{fill:#6fabe6;}.cls-4{fill:#82bcf4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_profile",
    "data-name": "User profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,24A23,23,0,1,1,12.81,3.91,23,23,0,0,1,47,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,24a22.91,22.91,0,0,1-8.81,18.09A22.88,22.88,0,0,1,27,45C5.28,45-4.37,17.34,12.81,3.91A23,23,0,0,1,47,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.2,35.39a19,19,0,0,1-30.4,0,17,17,0,0,1,10.49-8.73,8.93,8.93,0,0,0,9.42,0A17,17,0,0,1,39.2,35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.2,35.39a19,19,0,0,1-4.77,4.49,19,19,0,0,1-15.13-1,7.08,7.08,0,0,1-.51-12.18c.1-.07,0-.05.5-.05a9,9,0,0,0,9.42,0A17,17,0,0,1,39.2,35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,19a9,9,0,1,1-12.38-8.34A9,9,0,0,1,33,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33,19a9,9,0,0,1-2.6,6.33c-9.13,3.74-16.59-7.86-9.78-14.67A9,9,0,0,1,33,19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyUser);
export default __webpack_public_path__ + "static/media/dummyUser.2806ee3b9928529c0aec85cfa2b8141a.svg";
export { ForwardRef as ReactComponent };